import React from "react";

import $ from "jquery";

import Menu from "./menu";
import MenuIconContainer from "../containers/menu_icon";

class NotificationDropdown extends React.Component {
  constructor(...args) {
    super(...args);

    this.handleClickOnMenu = this.handleClickOnMenu.bind(this);
  }

  handleClickOnMenu() {
    $(document).on('click', '[data-mount="menu"]', function(event) {
      event.stopPropagation();
    });

    $(document).on('click', '[data-action="mark-as-read"]', function(event) {
      return false;
    });
  }

  render() {
    return (
      <div data-element="notification-dropdown">
        <MenuIconContainer onClick={this.handleClickOnMenu} />
        <Menu />
      </div>
    );
  }
}

export default NotificationDropdown;
